export const SALESTARGET_LOADING = "SALESTARGET_LOADING";
export const SALESTARGET_RESET = "SALESTARGET_RESET";
export const GET_SALESTARGET = "GET_SALESTARGET";
export const GET_SALESTARGET_SUCCESS = "GET_SALESTARGET_SUCCESS";
export const GET_SALESTARGET_FAIL = "GET_SALESTARGET_FAIL";
export const DELETE_SALESTARGET = "DELETE_SALESTARGET"
export const DELETE_SALESTARGET_SUCCESS = "DELETE_SALESTARGET_SUCCESS"
export const DELETE_SALESTARGET_FAIL = "DELETE_SALESTARGET_FAIL"
export const UPDATE_SALESTARGET = "UPDATE_SALESTARGET"
export const UPDATE_SALESTARGET_SUCCESS = "UPDATE_SALESTARGET_SUCCESS"
export const UPDATE_SALESTARGET_FAIL = "UPDATE_SALESTARGET_FAIL"
export const ADD_NEW_SALESTARGET = "ADD_NEW_SALESTARGET"
export const ADD_SALESTARGET_SUCCESS = "ADD_SALESTARGET_SUCCESS"
export const ADD_SALESTARGET_FAIL = "ADD_SALESTARGET_FAIL"